// Main JS file for jra25 theme
jQuery(document).ready(function ($) {
	// Initialize AOS only if it's loaded and needed
	if (typeof AOS !== 'undefined') {
		AOS.init({
			duration: 1000,
			ease: 'ease-out-quart',
			offset: 0,
			once: true,
		});

		$('main>.wp-block-group:not(.image-section)>.wp-block-group__inner-container, .entry-content>.wp-block-group:not(.image-section)>.wp-block-group__inner-container').attr('data-aos', 'zoom-in');
	}


	// Initialize Bootstrap tooltips
	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new bootstrap.Tooltip(tooltipTriggerEl);
	});

	// Initialize Bootstrap popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl);
	});

	

	// Add loading class to buttons
	$('.btn').on('click', function () {
		var $btn = $(this);
		if (!$btn.hasClass('btn-loading')) {
			$btn.addClass('btn-loading');
			setTimeout(function () {
				$btn.removeClass('btn-loading');
			}, 2000);
		}
	});

	// Work page, swap logos and case studies
	$('.case-studies-section .wp-block-buttons a').on('click', function (event) {
		event.preventDefault();
		event.stopPropagation();
		$('.wp-block-buttons a').parent().removeClass('active');
		$(this).parent().addClass('active');
		// var tab = $(this).attr('href');
		if ($(this).parent().hasClass('all-clients-btn')) {
			$('.case-study-grid').removeClass('active');
			$('#all-clients').addClass('active');
		} else {
			$('#all-clients').removeClass('active');
			$('.case-study-grid').addClass('active');
		}
	});


	$('.case-study-grid li').on('mouseenter', function(){
		$(this).addClass('active');
		if(window.innerWidth > 1080){
			var colNum = $(this).data('order') % 3; 
			if(colNum == 1){
				var sib1 = $(this).next();
				sib1.addClass('active-sib');
				sib1.next().addClass('active-sib');
			}else if (colNum == 2){			
				$(this).next().addClass('active-sib');
				$(this).prev().addClass('active-sib');
			}else{
				var sib1 = $(this).prev();
				sib1.addClass('active-sib');
				sib1.prev().addClass('active-sib');
			}
		}else{
			var colNum = $(this).data('order') % 2; 
			if(colNum == 1){
				var sib1 = $(this).next();
				sib1.addClass('active-sib');
			}else{
				var sib1 = $(this).prev();
				sib1.addClass('active-sib');
			}
		}


	}).on('mouseleave', function (){
		$('.case-study-grid li').removeClass('active active-sib');
	});


	// Accordion Collapse
	$('.accord-button a').attr('data-bs-toggle', 'collapse');
	$('.accord-button a').on('click', function(e){
		$(this).parent().toggleClass('open');
		e.stopImmediatePropagation();
	});


	// Smooth scrolling for anchor links
	$('a[href^="#"]').on('click', function (event) {
		var target = $(this.getAttribute('href'));
		if (target.length) {
			event.preventDefault();
			$('html, body').stop().animate({
				scrollTop: target.offset().top - 100
			}, 1000);
		}
	});

	// Custom theme functionality
	$('.navbar-toggler').on('click', function () {
		$('header').toggleClass('active');
	});

	// Single Case Study, video in body - Optimized to prevent blocking
	if($('body').hasClass('single-case_study')){
		// Defer video processing to avoid blocking main thread
		setTimeout(function() {
			var figure = $('.single-case_study .image-section figure');
			var source = figure.find('img').attr('src');
			if(source && source.includes('mp4')){
				var video = document.createElement('video');
				video.src = source;
				video.autoplay = true;
				video.loop = true;
				video.muted = true;
				video.preload = 'metadata'; // Optimize video loading
				video.playsInline = true;
				figure.replaceWith(video);
			}

			var figure = $('.single-case_study .case-study-gallery img');
			figure.each(function(){
				var source = $(this).attr('src');
				if(source && source.includes('mp4')){
					var video = document.createElement('video');
					video.src = source;
					video.autoplay = true;
					video.loop = true;
					video.muted = true;
					video.preload = 'metadata'; // Optimize video loading
					video.playsInline = true;
					$(this).replaceWith(video);
				}
			});
			
			// Initialize fsLightbox only if it exists
			if (typeof fsLightbox !== 'undefined') {
				fsLightbox.props.showThumbsOnMount = true;
			}
		}, 100); // Small delay to allow page to render first
	}

	// Swap Header on Scroll - Optimized with debouncing
	let scrollTimeout;
	function swapHeader(type){
		if(($(window).scrollTop() > 10 || type == 'click-on') && !$('header').hasClass('stay-dark')){
			$('header').addClass('scrolled dark-header');
			$('header img').attr('src', '/wp-content/themes/jra25/assets/images/james-ross-logo-black.svg');
		}else if((type == 'click-off' || ($(window).scrollTop() <= 10 && !$('header .dropdown-toggle').hasClass('show'))) && !$('header').hasClass('stay-dark')){
			$('header').removeClass('scrolled dark-header');
			$('header img').attr('src', '/wp-content/themes/jra25/assets/images/james-ross-logo.svg');
		}
	}
	
	// Debounced scroll handler to reduce main thread blocking
	$(window).on('scroll', function(){
		if($('header').hasClass('active')){
			return;
		}
		
		// Clear existing timeout
		if (scrollTimeout) {
			clearTimeout(scrollTimeout);
		}
		
		// Use requestAnimationFrame for smoother performance
		requestAnimationFrame(function() {
			scrollTimeout = setTimeout(function() {
				swapHeader();
			}, 10); // Small delay to batch scroll events
		});
	});

	$('header:not(.active) .dropdown-toggle, .navbar-toggler').on('click', function(){
		if($(this).hasClass('show') || $('header').hasClass('active')){
			swapHeader('click-on');
		}else{
			swapHeader('click-off');
		}
	});
	swapHeader();

	// Gallery button click handler - make gallery-button open first image instead of 4th

	
	// Use capture phase to intercept clicks before fsLightbox handles them
	document.addEventListener('click', function(e) {
		var target = e.target;
		// Check if click is on or inside the gallery-button link
		var galleryButtonLink = target.closest('.gallery-button a');
		
		if (galleryButtonLink && galleryButtonLink.hasAttribute('data-fslightbox')) {
			e.preventDefault();
			e.stopImmediatePropagation();

			// Check if lightbox is already open
			var lightboxContainer = document.querySelector('.fslightbox-container');
			var isLightboxOpen = lightboxContainer && 
								 (document.documentElement.classList.contains('fslightbox-open') || 
								  lightboxContainer.classList.contains('fslightbox-open'));
			
			if (!isLightboxOpen && typeof fsLightbox !== 'undefined') {
				// galleryButtonOpening = true;
				
				// Immediately open at index 0 (first image)
				// Try to access the specific fsLightbox instance for "gallery"
				if (typeof window.fsLightboxInstances !== 'undefined' && window.fsLightboxInstances['gallery']) {
					window.fsLightboxInstances['gallery'].open(0);
				} else if (typeof fsLightbox !== 'undefined') {
					// Fallback to global fsLightbox instance
					fsLightbox.open(0);
				}
			}
			
			return false;
		}
	}, true); // Use capture phase to intercept before fsLightbox

	$('.swiper-block-logos .swiper-wrapper').each(function(){
		var numSlides = $(this).children().length;
		// console.log(numSlides);
		if(numSlides <= 6){
			$(this).addClass('static');
		}
	});


	function setCaseStudySliderHeight(){
		// maxHeight = Math.max(...$('.case-study-slider .swiper-slide .case-study-card').map(function(){
		// 	console.log($(this).height());
		// 	console.log($(this));
		// 	return $(this).height();
		// }));
		var maxHeight = 0;
		$('.case-study-card').each(function(){
			var metaHeight = $(this).children('.case-study-meta').height();
			var totalHeight = $(this).width() + metaHeight + 28;
			if (totalHeight > maxHeight){
				maxHeight = totalHeight;
			}
		});
		$('.case-study-slider .swiper-slide').height(maxHeight);
	}
	setCaseStudySliderHeight();
	$(window).resize(function(){
		setCaseStudySliderHeight();
	});


	function replayVideo(video) {
		if(video.currentTime > 3){
			video.currentTime = 0;
			video.play();
		}
	}
	$('.icon-animation').mouseenter(function(){
		var video = $(this).find('video').get(0);
		video.loop = true;
		video.play();
		video.playbackRate = 2;
		// Store the handler function so it can be removed later
		video._timeupdateHandler = function() { replayVideo(video); };
		video.addEventListener('timeupdate', video._timeupdateHandler);
	}).mouseleave(function(){
		var video = $(this).find('video').get(0);
		console.log('pause');
		video.loop = false;
		// Use the stored handler reference to properly remove the listener
		if(video._timeupdateHandler) {
			video.removeEventListener('timeupdate', video._timeupdateHandler);
			video._timeupdateHandler = null;
		}
		video.addEventListener('ended', function() {
			video.load();
		});
	});
	// });
});